export var TrackListEvents;!function(t){t.CHANGE="change",t.ADD_TRACK="addtrack",t.REMOVE_TRACK="removetrack"}(TrackListEvents||(TrackListEvents={}));